import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChildren,
  QueryList,
  ElementRef,
} from '@angular/core';
import { currencyFormatter } from 'src/app/utils/currencyFormatter';

@Component({
  selector: 'app-filter-radio-button',
  templateUrl: './filter-radio-button.component.html',
  styleUrls: ['./filter-radio-button.component.scss'],
})
export class FilterRadioButtonComponent implements OnInit {
  @Input() radioButtonData!: any;
  @Input() key!: any;
  @Input() showSubtitle: boolean = false;

  @Output() radioOutput = new EventEmitter<string>();

  public active: boolean = true;

  @ViewChildren('radioAll, radioYes') radioButtons!: QueryList<ElementRef>;

  constructor() {}

  ngOnInit(): void {}

  onClick(val: string): void {
    this.active = !this.active;
    let obj: any = {
      value: val == 'ALL' ? ['ALL'] : ['YES'],
      key: this.key,
    };
    this.radioOutput.emit(obj);
  }

  currencyFormatter = currencyFormatter;

  onKeydown(event: KeyboardEvent): void {
    if (this.radioButtonData.value === 'DISABLED') {
      event.preventDefault();
      return;
    }

    const options = ['ALL', 'YES'];
    const currentIndex = options.indexOf(this.radioButtonData.value);
    let newIndex = currentIndex;

    switch (event.key) {
      case 'ArrowLeft':
      case 'ArrowUp':
        if (currentIndex > 0) {
          newIndex = currentIndex - 1;
          this.onClick(options[newIndex]);
          this.focusRadio(newIndex);
          event.preventDefault();
        }
        break;
      case 'ArrowRight':
      case 'ArrowDown':
        if (currentIndex < options.length - 1) {
          newIndex = currentIndex + 1;
          this.onClick(options[newIndex]);
          this.focusRadio(newIndex);
          event.preventDefault();
        }
        break;
      default:
        break;
    }
  }

  focusRadio(index: number): void {
    const radios = this.radioButtons.toArray();
    if (radios[index]) {
      radios[index].nativeElement.focus();
    }
  }
}
